import { render } from "./setSelfNewPass.vue?vue&type=template&id=c8941a8a&scoped=true"
import script from "./setSelfNewPass.vue?vue&type=script&lang=js"
export * from "./setSelfNewPass.vue?vue&type=script&lang=js"

import "./setSelfNewPass.vue?vue&type=style&index=0&id=c8941a8a&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8941a8a"]])

export default __exports__